import styled from 'styled-components';
import CafeSvg from '../../assets/amenities/cafe.svg';

const CafeIcon = styled(CafeSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default CafeIcon;
